module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gray-back",
    staticStyle: {
      "height": "100%"
    }
  }, [(_vm.user.id > 1) ? _c('div', {
    staticStyle: {
      "margin": "10px",
      "color": "#fff",
      "background": "#000",
      "padding": "10px",
      "border-radius": "10px"
    },
    on: {
      "click": function($event) {
        return _vm.logout()
      }
    }
  }, [_vm._v(_vm._s(_vm.user.name) + "[切换账号]")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticStyle: {
      "position": "relative"
    }
  }, [_c('div', {
    staticStyle: {
      "padding": "10px"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": _vm.row.pic_url
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "savebtn",
    staticStyle: {
      "text-align": "center",
      "position": "absolute",
      "bottom": "40px",
      "left": "0",
      "right": "0"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "savebtn",
    staticStyle: {
      "text-align": "center",
      "margin-bottom": "10px"
    }
  }, [(_vm.user.id > 1) ? _c('van-button', {
    directives: [{
      name: "rblink",
      rawName: "v-rblink",
      value: ({
        name: 'ISaiApplyListDianxin',
        query: {}
      }),
      expression: "{name:'ISaiApplyListDianxin',query:{}}"
    }],
    staticStyle: {
      "width": "3rem"
    },
    attrs: {
      "size": "normal",
      "round": ""
    }
  }, [_vm._v("上传记录\n          ")]) : _vm._e(), _vm._v(" "), _c('van-button', {
    staticStyle: {
      "width": "3rem"
    },
    attrs: {
      "color": "linear-gradient(90deg, rgb(254, 200, 53) 0%, rgb(255, 173, 25) 100%)",
      "size": "normal",
      "round": ""
    },
    on: {
      "click": function($event) {
        return _vm.go()
      }
    }
  }, [_vm._v("开始上传\n          ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "savebtn",
    staticStyle: {
      "text-align": "center"
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f3793b2a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/apps/page/Dianxin.vue
// module id = 2614
// module chunks = 0